import { Selector } from "../common/Selector";
import { AIResponseSave } from "winslow-core";
import { getCategoryColor } from "./colorData";

type CategorySelectorProps = {
  responses: AIResponseSave[];
  onChange: (value: string) => void;
};

export const CategorySelector = ({
  responses,
  onChange,
}: CategorySelectorProps) => {
  const categories: string[] = [];

  responses.forEach((response: AIResponseSave) => {
    if (response.category && !categories.includes(response.category)) {
      categories.push(response.category);
    }
  });

  const options = categories.map((category) => ({
    value: category,
    label: category,
    imageUrl: undefined,
    color: getCategoryColor(category),
  }));

  // Add the "(no filter)" option at the beginning
  options.unshift({
    value: "",
    label: "(no filter)",
    imageUrl: undefined,
    color: "",
  });

  return <Selector options={options} onChange={onChange} />;
};
